// extracted by mini-css-extract-plugin
module.exports = {"root":"BlackList_root__64y9F"};